import FormatOption from './FormatOption';

export default class IncludeHash extends FormatOption {

    static default = true;
    static label   = 'Include #';

    output() {
        let output = this.decorator.output();

        return '#' + output;
    }

}